/**
 * Labstep
 *
 * @module components/ProtocolValue/Detail/Amount
 * @desc ProtocolValue Detail Amount
 */

import { EntityDetailTable } from 'labstep-web/components/Entity/Detail/Table';
import type React from 'react';
import type { IProtocolValueDetailAmountProps } from './types';
import { getAmountRows } from './utils';

export const ProtocolValueDetailAmount: React.FC<
  IProtocolValueDetailAmountProps
> = ({ protocolValue }) => (
  <EntityDetailTable
    columns={[protocolValue]}
    rows={getAmountRows(protocolValue)}
  />
);
